import { fPercent } from "src/utils/format-number";
import useLocales from "src/locales/use-locales";
import BreakdownTooltip from "./breakdown-tooltip";

// Same colors and icons as the Brand presence breakdown (PresenceRateChartNew); the competitors' bar tint is
// too pale for an icon, which takes the grey of the values instead
const ORGANIC = { color: '#18A155', iconColor: '#18A155', icon: 'solar:global-linear' };
const PAID = { color: '#C09910', iconColor: '#C09910', icon: 'carbon:user' };
const COMPETITORS = { color: 'rgba(145, 158, 171, 0.20)', iconColor: '#637381', icon: 'ri:sword-line' };

/**
 * Visibility rate split into its organic-only and paid parts (they add up to it), plus the SERPs
 * where only competitors show (100 - visibility rate, like the Brand presence breakdown).
 */
export default function VisibilityRateTooltip({
    visibilityRate,
    organic,
    paid,
}: {
    visibilityRate: number;
    organic: number | null;
    paid: number | null;
}) {
    const { t } = useLocales();
    const competitorsOnly = Math.max(0, 100 - visibilityRate);
    const parts = [
        { ...ORGANIC, label: t('dashboard.nonBrand.visibilityBreakdown.organic'), value: organic ?? 0 },
        { ...PAID, label: t('dashboard.nonBrand.visibilityBreakdown.paid'), value: paid ?? 0 },
        { ...COMPETITORS, label: t('dashboard.nonBrand.visibilityBreakdown.competitorsOnly'), value: competitorsOnly },
    ];
    return (
        <BreakdownTooltip
            title={t('dashboard.nb_brand_grid.columns.title.visibility_rate')}
            total={fPercent(visibilityRate)}
            segments={parts.map(({ value, color }) => ({ value, color }))}
            rows={parts.map(({ label, value, iconColor, icon }) => ({ label, value: fPercent(value), color: iconColor, icon }))}
        />
    );
}
